<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <div v-if='qry'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-search" @click='buttonClk("search")' :title='$t("TS.ts_search")'/></div>
      </div>
    </ejs-toolbar>
    <div v-if='keywordsInput' class='h-inputBox'>
      <ejs-textbox v-model='queryConditions.keywords' :placeholder='$t("Track.pleaseEnterQuery")' @keydown.native='updateKeywords'></ejs-textbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TsMenuButton',
  props: {
    qry: { type: Boolean, default: true },
    keywordsInput: { type: Boolean, default: false }
  },
  data() {
    return {
      queryConditions: {
        keywords: '', // 模糊查询关键字
      }
    };
  },
  methods: {
    buttonClk(args) {
      console.log(args);
      this.$emit('methodEnum', args);
    },
    updateKeywords(clickEvent) {
      if (clickEvent.keyCode === 13) {
        this.$emit('keywords', this.queryConditions.keywords.trim());
      }
    }
  }
};
</script>

<style scoped>

</style>
